module.exports = __webpack_public_path__ + "static/media/C (7).e12093f8.jpg";